export default __webpack_public_path__ + "static/media/goshoppi.e0a3af21.jpeg";